import apiClient from './client';
import type {
  OvercallingCandidatesResponse,
  OvercallingCandidateItem,
  OvercallingCurationRecord,
  OvercallingFilter,
} from '../types/overcallingDataEditing';

// API client for the Overcalling Data Editing page.
// Matches contracts/overcalling-data-editing-api.md.
// Introduced by feature 009-overcalling-data-editing.
//
// Session 2026-05-20 scope reduction: getBySerial, keepProblem, and rejectProblem
// were removed because teaching problems are OUT OF SCOPE for curation. Only the
// 4 surviving endpoints are exposed.

export const overcallingDataEditingApi = {
  async getCandidates(filter: OvercallingFilter): Promise<OvercallingCandidatesResponse> {
    const response = await apiClient.get<OvercallingCandidatesResponse>(
      '/overcalling-data-editing/candidates',
      { params: { filter } }
    );
    return response.data;
  },

  async getByTableResultId(tableresultId: number): Promise<OvercallingCandidateItem> {
    // skipRedirectOn404 lets the page render a friendly "not found" message
    // instead of bouncing to the generic error page (FR-042).
    const response = await apiClient.get<OvercallingCandidateItem>(
      `/overcalling-data-editing/candidate/by-id/${tableresultId}`,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      { skipRedirectOn404: true } as any
    );
    return response.data;
  },

  async keepHand(tableresultId: number): Promise<OvercallingCurationRecord> {
    const response = await apiClient.post<OvercallingCurationRecord>(
      `/overcalling-data-editing/hands/${tableresultId}/keep`
    );
    return response.data;
  },

  async rejectHand(tableresultId: number): Promise<OvercallingCurationRecord> {
    const response = await apiClient.post<OvercallingCurationRecord>(
      `/overcalling-data-editing/hands/${tableresultId}/reject`
    );
    return response.data;
  },
};
